import SocketFactory from '@/drivers/socket'
import { loadImage } from '@/utils/load-image'

import type { PrinterConfig } from '../types'
import { StarPrntEncoder } from './star-prnt-encoder'

export default class StarPrnt {
  private config: PrinterConfig

  constructor(config: PrinterConfig) {
    this.config = config
  }

  printImage(imageData: string) {
    return new Promise<void>((resolve, reject) => {
      const rejectMiddleware = (error: unknown) => {
        reject(error)
      }
      const socket = SocketFactory.getSocket()
      socket.open(
        this.config.address,
        9100,
        async () => {
          const img = await loadImage(imageData)

          const width = 576
          const ratio = width / img.width
          const height = Math.round((img.height * ratio) / 8) * 8

          const encoder = new StarPrntEncoder()
          const result = encoder
            .initialize()
            .align('center')
            .image(img, width, height)
            .cut()
            .encode()

          socket.write(
            result,
            () => {
              socket.shutdownWrite(() => {
                resolve()
              }, rejectMiddleware)
            },
            rejectMiddleware
          )
        },
        rejectMiddleware
      )
    })
  }

  openCashDrawer() {
    return new Promise<void>((resolve, reject) => {
      const rejectMiddleware = (error: unknown) => {
        reject(error)
      }
      const socket = SocketFactory.getSocket()
      socket.open(
        this.config.address,
        9100,
        () => {
          const encoder = new StarPrntEncoder()
          const result = encoder.initialize().openCashDrawer().encode()

          socket.write(
            result,
            () => {
              socket.shutdownWrite(() => {
                resolve()
              }, rejectMiddleware)
            },
            rejectMiddleware
          )
        },
        rejectMiddleware
      )
    })
  }
}
